module.exports = __webpack_public_path__ + "static/media/bitlock_image.0f73f97d.png";